import getActions from "./actionsPopupUtils";

const material_terms_actions = (formName, isSubaccount) => {
  return getActions({ formName, isSubaccount, shared: true });
};

export default material_terms_actions;
